import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const CellValue = styled.span<{ $em?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: ${({ $em }) => ($em ? 700 : 600)};
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const VarianceValue = styled.span<{ $tone: 'danger' | 'positive' | 'normal' | 'dim' }>`
  font-size: ${tokens.font.body};
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ $tone }) =>
    $tone === 'danger'
      ? tokens.status.danger.fg
      : $tone === 'positive'
        ? tokens.status.success.fg
        : $tone === 'dim'
          ? tokens.text.muted
          : tokens.text.secondary};
`

export const SheetNoteText = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const SheetCaption = styled.p`
  margin-top: 0.5rem;
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const CaptionLine = styled.p`
  margin-top: 1rem;
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const CountInput = styled.input`
  width: 6rem;
  padding: 0.25rem 0.5rem;
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.strong};
  border-radius: ${tokens.radius.chip};
  color: ${tokens.text.primary};
  font-size: ${tokens.font.body};
  font-variant-numeric: tabular-nums;

  &:focus {
    outline: none;
    border-color: ${tokens.accent.base};
  }
`

export const ApproverLine = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.status.success.fg};
`

export const DetailMetaLine = styled.p`
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
`

export const MaskedValue = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 700;
  letter-spacing: 0.25em;
  color: ${tokens.text.muted};
`

export const OverLimitTag = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  gap: 0.375rem;
  margin-left: 0.5rem;
  font-size: ${tokens.font.micro};
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${tokens.status.danger.fg};

  &::before {
    content: '';
    width: 0.375rem;
    height: 0.375rem;
    border-radius: 999px;
    background: ${tokens.status.danger.fg};
  }
`

export const MicroNote = styled.p`
  margin-top: 0.25rem;
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`
